/// <reference path='../../../../../../typings/index.d.ts' />

module Meevo.Plugins.DocsAndForms {
    import ISelectItem = Meevo.Model.ISelectItem;

    class SendFormViaComponent implements ng.IComponentController {
        model: DocsAndFormsModel;
        daysBeforeAppointmentItems: ISelectItem<number>[];
        valid: boolean;
        form: ng.IFormController;

        get showMessageSent(): boolean {
            return this.model && this.model.deliveryMethodEnum !== FormAndDocsDelivery.DoNotSend;
        }

        $onInit() {
            this.daysBeforeAppointmentItems = Array.from(Array(14).keys())
                .map((i) => ({value: i + 1, label: (i + 1).toString()}));

            setTimeout(() => {
                this.validate();
            });
        }

        changeDeliveryMethod() {
            if (!this.model.deliveryMethodText && !this.model.deliveryMethodEmail) {
                this.model.deliveryMethodEnum = FormAndDocsDelivery.DoNotSend;
                this.model.sendUponBooking = false;
                this.model.sendUponConfirming = false;
                this.model.sendXDaysBeforeAppointment = false;
                this.model.daysBeforeAppointment = null;
                this.model.sendUponFinalizeTransaction = false;

                return;
            }

            else if (this.model.deliveryMethodText || this.model.deliveryMethodEmail) {
                if (this.model.formFillTypeEnum == FormFillTypeEnum.Membership) {
                    this.model.sendUponFinalizeTransaction = true;
                }
                else if (this.model.formFillTypeEnum == FormFillTypeEnum.PaymentPlan) {
                    this.model.sendUponFinalizeTransaction = true;
                }
                else if (this.model.formFillTypeEnum == FormFillTypeEnum.OnlyOnce || this.model.formFillTypeEnum == FormFillTypeEnum.EveryTime) {
                    this.model.sendUponFinalizeTransaction = false;
                    this.model.daysBeforeAppointment = 1;
                }

                if (this.model.deliveryMethodText && this.model.deliveryMethodEmail) {
                    this.model.deliveryMethodEnum = FormAndDocsDelivery.TextAndEmail;
                } else if (this.model.deliveryMethodText) {
                    this.model.deliveryMethodEnum = FormAndDocsDelivery.TextMessage;
                } else if (this.model.deliveryMethodEmail) {
                    this.model.deliveryMethodEnum = FormAndDocsDelivery.Email;
                }
            }
        }


        validate() {
            if (this.model.deliveryMethodEnum === FormAndDocsDelivery.DoNotSend) {
                this.valid = true;
            } else if (this.model.formFillTypeEnum == FormFillTypeEnum.OnlyOnce || this.model.formFillTypeEnum == FormFillTypeEnum.EveryTime) {
                this.valid = this.model.sendUponBooking || this.model.sendUponConfirming || this.model.sendXDaysBeforeAppointment;
            } else if (this.model.formFillTypeEnum === FormFillTypeEnum.Membership) {
                this.valid = this.model.sendUponFinalizeTransaction;
            } else if (this.model.formFillTypeEnum === FormFillTypeEnum.PaymentPlan) {
                this.valid = this.model.sendUponFinalizeTransaction;
            }

            this.form['sendForm'].$setValidity('required', !!this.valid);
        }
    }

    angular.module('meevo.components.controls')
        .component('sendFormViaControl', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/send-form-via-control/send-form-via-control.component.html',
            controller: SendFormViaComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '=ngModel',
                disabled: '<ngDisabled'
            },
            require: {
                form: '^form',
            }
        });
}
